import axios from './axiosConfig'
import type { ApiRequestOptions } from './requestOptions'

interface PurchaseItemData {
 product_id: number
 quantity: number
 cost_price: number
 unit_id?: number
 production_date?: string
 expiry_date?: string
 batch_number?: string
 variant_id?: string | null
}

interface PurchaseData {
 supplier_id: number
 purchase_date: string
 items: PurchaseItemData[]
 subtotal: number
 tax?: number
 discount?: number
 paid: number
 financial_account_id?: string | null
 payment_branch_id?: string | null
 notes?: string
 warehouse_id?: string | null
 branch_id?: string | null
 invoice_number?: string | null
}

export const purchasesAPI = {
 getAll: async (params?: any, options?: ApiRequestOptions) => {
 const response = await axios.get('/purchases', { params, ...options })
 return response.data
 },

 getById: async (id: number, options?: ApiRequestOptions) => {
 const response = await axios.get(`/purchases/${id}`, options)
 return response.data
 },

 create: async (data: PurchaseData) => {
 const response = await axios.post('/purchases', data)
 return response.data
 },

 update: async (id: number, data: Partial<PurchaseData>) => {
 const response = await axios.put(`/purchases/${id}`, data)
 return response.data
 },

 delete: async (id: number) => {
 const response = await axios.delete(`/purchases/${id}`)
 return response.data
 },

 getPayments: async (purchaseId: number) => {
 const response = await axios.get(`/purchases/${purchaseId}/payments`)
 return response.data
 },

 addPayment: async (purchaseId: number, payload: {
 amount: number
 payment_date: string
 notes?: string
 client_uuid?: string
 financial_account_id?: string
 payment_branch_id?: string
 vault_id?: string
 payment_method?: string
 reference_no?: string
 }) => {
 const response = await axios.post(`/purchases/${purchaseId}/payments`, payload)
 return response.data
 },

 timeline: async (id: number) => {
 const response = await axios.get(`/purchases/${id}/timeline`)
 return response.data
 },
}
